/* eslint-disable no-undef */
export const UPDATE_ENDPOINT = 'https://kinetichosting.com/api/sftp-updates?latest=true';

export const APP_VERSION = typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : '0.0.0';

export const parseVersionParts = (value) => {
  if (!value) return [];
  return value.
  split('.').
  map((p) => parseInt(p, 10)).
  filter((n) => !isNaN(n));
};

export const compareVersions = (a, b) => {
  const partsA = parseVersionParts(a);
  const partsB = parseVersionParts(b);
  const len = Math.max(partsA.length, partsB.length);
  for (let i = 0; i < len; i++) {
    const valA = partsA[i] || 0;
    const valB = partsB[i] || 0;
    if (valA > valB) return 1;
    if (valA < valB) return -1;
  }
  return 0;
};
